import React, { useState, useEffect } from 'react';
import Navbar from './global-components/navbar-v2';
import ResultatRech from './resultat-rech';
import Footer from './global-components/footer-v2';
import Scrollp from './Scroll-Parallax/scrollp';
import { Link } from 'react-router-dom';
import FormulaireInscriptionEnLigne from './global-components/formulaire-inscritenligne'; // Import du formulaire
const RechercheResult = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [isPopupVisible, setIsPopupVisible] = useState(false); // État pour afficher ou masquer le popup

  const handleOpenPopup = () => {
    setIsPopupVisible(true);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  return (
    <div>
      <Navbar />
      <div className="content-layout">
        <main className="main-content">
          <ResultatRech />
        </main>
      </div>
      <Footer />
      <Scrollp />
      <div className="fixed-buttons">
        <Link to="/Formateur">
          <button className="btn btn-primary">Devenir formateur</button>
        </Link>
        <Link to="/inscriptionenligne">
          <button className="btn btn-secondary">Inscription en ligne</button>
        </Link>
      </div>

      {/* Popup */}
      {isPopupVisible && (
        <div className="popup-overlay ">
          <div className="popup-content ">
            {/* Formulaire d&apos;inscription */}
            <FormulaireInscriptionEnLigne />
            <button onClick={handleClosePopup} className="popup-close-button">
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RechercheResult;
